<div class="product-details">
  <div class="container">
    @if (product) {
      @if (product.status !== advertStatus.Publish || !checkIsActive()) {
        <div class="row">
          <div class="col-12">
            <div class="expired-warning">
              <div class="warning-text">
                Denne tilbud er ikke længere aktuelt. Vi inviterer dig til at se
                andre forslag på vores hjemmeside.
              </div>
            </div>
          </div>
        </div>
      }
      <div class="product-details-child">
        <app-product-details-image-area
          [advert]="product"></app-product-details-image-area>
        <!-- END! product-details-image-area -->
        <app-advert-details-right-area
          [advert]="product"></app-advert-details-right-area>
        <!-- END! product-details-right-area -->
      </div>
      <!-- END! product-details-child -->

      <div class="pricing-select-day two">
        <app-select-days [product]="product"></app-select-days>
        @if (product.pricing) {
          <app-product-details-pricing
            [pricings]="product.pricing"></app-product-details-pricing>
        }
      </div>
    }
  </div>
</div>
